import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const FamilyListStyle = (theme: Theme) => createStyles({
  familyList: {
    display:'flex',
    flexWrap: 'wrap',
    columnGap:'30px',
    rowGap:'30px',
  },
  familyItem: {
    position: "relative",
    boxShadow: `0px 3px 30px ${styleColors.softPurpleShadow}`,
    background:styleColors.white,
    padding:'12px',
    borderRadius:'12px',
    flex: 1,
  },
  familyContent: {
    display:'flex',
    alignItems: 'center',
    gap:'25px'
  },
  primaryText:{
    fontSize:'16px',
    fontWeight:'bold',
    margin: '5px 50px 0px 0px',
  },
  deletedPrimaryText:{
    textDecoration: 'line-through',
  },
  secondaryText:{
    fontSize:'14px',
    fontWeight:'normal',
    margin: '5px 50px 0px 0px',
    wordBreak: 'break-word',
  },
  colorPaper : {
    minWidth: '150px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '8px',
  },
  colorOption : {
    flex:1,
    minHeight: '24px',
  }
});



// WEBPACK FOOTER //
// ./src/components/extended-family/family-list/FamilyList.style.ts